export default {
  Queued: 4,
  PendingApproval: 2,
  Ready: 3,
  PendingIssues: 9,
  Unclassified: 1,
  PendingAnalysis: 7,
};
